import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {ActionService} from "../services/authorization-management/action/action.service";
import {AuthService} from "../services/auth/auth.service";

@Directive({
  selector: '[permission-action]'
})
export class HasPermissionDirective implements OnInit {
  @Input('permission-action') requiredPermissions: string = '';

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    private readonly actionService: ActionService,
    private readonly authService: AuthService
  ) {
  }

  ngOnInit() {
    if (!this.authService.isSuperAdmin()) {
      const permissionArray = this.requiredPermissions.split(',').map(p => p.trim());
      if (permissionArray[0].length != 0) {
        this.actionService.actionCheck(permissionArray[0], permissionArray[1]).then(response => {
          if (!response) {
            this.renderer.removeChild(this.el.nativeElement.parentNode, this.el.nativeElement);
          }
        });
      }
    }

  }
}
